module.exports = __webpack_public_path__ + "media/soundtrack.4d3d727a.mp3";